//imports
import React from 'react';
import { injectIntl } from 'react-intl';

//controls
import { Container, Paper } from '@mui/material';
import { useSelector } from "react-redux";
import DashboardPanel from '../dashboardPanel';

const SettingsMainView = (props) => {
    //intl
    const { messages } = props.intl;

    //Global state
    const user = useSelector((state) => state.securityRedux.user);
    return (
        <Container maxWidth={false} className="container-view">
            <Paper elevation={0}>
                <DashboardPanel />
              <div id="portal-root"></div>
            </Paper>
        </Container>
    );
}

export default injectIntl(SettingsMainView);
